var ControlGroup          = require("app/ui/ControlGroup"),
    ControlLabel          = require("app/ui/ControlLabel"),
    FilterBar             = require("./FilterBar.js"),
    IconButton            = require("app/ui/IconButton"),
    InputWrapper          = require("app/ui/InputWrapper"),
    Input                 = require("app/ui/Input"),
    PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    Signals               = require("enyo/Signals"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    get                   = require("object-path").get,
    icons                 = require("app/theme/icons"),
    kind                  = require("enyo/kind"),
    quickMacroize         = require("enyo/macroize").quickMacroize;

require("./SearchForm.less");
require("app/ui/ControlGroup.less");
require("app/theme/ControlGroup--default.less");
require("app/theme/ControlLabel--default.less");
require("app/theme/Input--default.less");
require("app/theme/IconButton--input-light.less");

module.exports = kind(/** @lends  app.SearchPage.SearchForm.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.SearchForm",

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    classes: "app-search-page-search-form",

    /**
     * @private
     */
    tag: "form",

    /**
     * @private
     */
    attributes: {
        onsubmit: "return false;"
    },

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @type     {boolean}
     * @default  'false'
     * @readonly
     * @public
     */
    isSearching: false,

    /**
     * @private
     */
    components: [{
        kind:    Signals,
        onkeyup: "handleKeyUp"
    }, {
        kind:       ControlGroup,
        classes:    "app-search-page-search-form__query",
        components: [{
            name:    "queryLabel",
            kind:    ControlLabel,
            classes: "app-search-page-search-form__query-label h1",
            theme:   "default"
        }, {
            kind:       InputWrapper,
            components: [{
                name:       "queryInput",
                kind:       Input,
                classes:    "double-icon-right",
                type:       "text",
                attributes: {
                    name:     "query",
                    required: "required",
                    pattern:  "[^\\\/]*"
                },
                theme:  "default",
                onblur: "onFormControlBlur"
            }, {
                name:    "searchButton",
                kind:    IconButton,
                classes: "app-search-page-search-form__search-button right-of-input",
                tag:     "button",
                theme:   "input-light",
                icon:    icons["app.SearchPage.SearchForm.searchButton"],
                ondown:  "onSearchButtonDown",
                ontap:   "requestSearch"
            }, {
                name:    "clearButton",
                kind:    IconButton,
                classes: "app-search-page-search-form__clearButton right-of-input-2",
                tag:     "button",
                theme:   "input-default",
                icon:    icons["app.SearchPage.SearchForm.clearButton"],
                ontap:   "clearQuery"
            }]
        }, {
            name:    "queryInstructions",
            classes: "app-ui-control-instructions"
        }]
    }, {
        name:       "typeInput",
        kind:       Input,
        type:       "hidden",
        attributes: {
            name: "type"
        }
    }, {
        name:    "filterBar",
        kind:    FilterBar,
        classes: "app-search-page-search-form__filter-bar"
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".$.filterBar.type",
        to:   ".$.typeInput.value"
    }],

    /**
     * @private
     */
    handlers: {
        requestSearch: "requestSearch"
    },

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @method
     * @private
     */
    rendered: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            // Ensure proper label referencing for accessibility
            this.$.queryLabel.setAttribute("for", this.$.queryInput.getAttribute("id"));
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            state       = this.state || {},
            $queryInput = this.$.queryInput,
            $filterBar  = this.$.filterBar;

        this.$.queryLabel.set("content", i18nService.getString("app.SearchPage.SearchForm.Query.label"));

        $queryInput.set("tooltip", i18nService.getString("app.SearchPage.SearchForm.Query.instructions"));
        $queryInput.set("value", get(state, "params.query", null) || "");

        this.$.queryInstructions.set("content", i18nService.getString("app.SearchPage.SearchForm.Query.instructions"));

        this.$.clearButton.set("tooltip", i18nService.getString("app.SearchPage.SearchForm.clearButton.tooltip"));

        this.$.searchButton.set("tooltip", i18nService.getString("app.SearchPage.SearchForm.SearchButton.tooltip"));

        $filterBar.set("showing", true);
        $filterBar.set("state", state);
    },

    /**
     * @method
     * @private
     */
    absoluteShowingChanged: kind.inherit(function(sup) {
        return function() {
            var state      = this.state || {},
                numResults = get(state, "results.length", null) || 0;

            sup.apply(this, arguments);

            if (this.absoluteShowing
                && numResults === 0
                && !this.app.$.continueSignUpPopup.get("showing")
                && !this.app.$.privacyService.get("cmpUiShown")
            ) {
                this.$.queryInput.focus();
            }
        };
    }),

    /**
     * Empty the query input.
     *
     * @private
     */
    clearQuery: function() {
        var $queryInput = this.$.queryInput;

        $queryInput.set("value", null);
    },

    // Submit email login form
    // --------------------------------
    // The methods below are used to handle email login form submission.
    // --------------------------------

    /**
     * Submit form if pressing enter while focus is within the form.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @returns  {Boolean}       Maybe stop propagation
     * @private
     */
    handleKeyUp: function(sender, event) {
        var node;

        if (!this.isSearching
            && (event.key === "Enter" || event.keyCode === 13)
            && (node = this.hasNode())
            && node.contains(document.activeElement)
        ) {
            event.preventDefault();
            this.requestSearch();

            return true;
        }

        return false;
    },

    /**
     * Should prevent blurring the search input.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    onSearchButtonDown: function(sender, event) {
        event.preventDefault();
    },

    /**
     * Validate the form and submit a search request needed.
     *
     * @param  {?enyo.Control}  sender  The sender
     * @param  {?Object}        event   The event
     * @private
     */
    requestSearch: function(sender, event) {
        var i18nService = this.app.$.i18nService,
            formNode    = this.hasNode(),
            formData    = formNode ? new FormData(formNode) : null,
            autofocusNode,
            path,
            queryString = "";

        // Don't send, we'll go through the router for that.
        event && event.preventDefault && event.preventDefault();

        // Nothing to do right now.
        if (!formNode || this.isSearching) {
            return;
        }

        // If form isn't valid, focus first field with error and leave it at
        // that.
        if (!this.validateForm()
            && !this.app.$.continueSignUpPopup.get("showing")
            && !this.app.$.privacyService.get("cmpUiShown")
        ) {
            autofocusNode = formNode.querySelector(".invalid");
            autofocusNode && autofocusNode.focus();

            return;
        }
        else if (formNode.contains(document.activeElement)) {
            document.activeElement.blur();
        }

        // Submit form
        path = quickMacroize("/{$language}/search/{$query}", {
            language: i18nService.get("language"),
            query:    encodeURIComponent(formData.get("query"))
        });

        if (formData.get("type")) {
            queryString = "?" + new URLSearchParams({
                type: formData.get("type")
            }).toString();
        }

        this.app.$.router.navigate(path + queryString);
    },

    /**
     * Validate form field on blur.
     *
     * @param  {enyo.Control}  sender  The control that just blurred.
     * @protected
     */
    onFormControlBlur: function(sender) {
        this.validateField(sender);
    },

    /**
     * Validate the entire form.
     *
     * @returns  {boolean}  Whether the form is valid.
     * @protected
     */
    validateForm: function() {
        var controlNames = ["queryInput"],
            isValid      = true;

        controlNames.forEach(this.bindSafely(function(name) {
            var control = this.$[name];

            if (!control || !this.validateField(control)) {
                isValid = false;
            }
        }));

        return isValid;
    },

    /**
     * Validates the field, returns whether it is valid.
     *
     * @param  {enyo.Control}  control  The form control
     * @return {boolean}       `true` if valid, `false` otherwise
     */
    validateField: function(control) {
        var node = control.hasNode();

        // Field is valid
        if (node && (
            node.disabled
            || node.type === "submit"
            || node.validity.valid)) {
            control.removeClass("invalid");

            return true;
        }

        // Field is invalid
        else {
            control.addClass("invalid");

            return false;
        }
    }

});
